import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, Location, NgOptimizedImage } from '@angular/common';
import { ToastService } from '../../core/services/toast.service';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzTabChangeEvent, NzTabsModule } from 'ng-zorro-antd/tabs';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css',
  standalone: true,
  providers: [ToastService],
  imports: [
    RouterModule,
    NgOptimizedImage,
    CommonModule,
    NzGridModule,
    SvgIconComponent,
    NzTabsModule,
  ],
})
export class AuthComponent implements OnInit {
  currentAuthForm = 'login';
  authForm: FormGroup;
  router = inject(Router);
  location = inject(Location);

  // onTabChange(event: NzTabChangeEvent) {
  //   const { tab } = event;

  //   if (tab.nzTitle === 'Setup') {
  //     this.router.navigate(['/auth/setup']);
  //   } else {
  //     this.router.navigate(['/auth', 'login']);
  //   }
  // }

  goBack() {
    this.location.back();
  }

  ngOnInit(): void {
    this.authForm = new FormGroup({
      email: new FormControl(null),
      password: new FormControl(null),
    });
  }

  get currentPath(): string {
    return this.router.url;
  }

  switchForms(formType: 'login' | 'register') {
    this.currentAuthForm = formType;
  }
}
